import Joyride from "react-joyride";

const TourGuide = ({ steps, runTour, onCallback }) => {
  return (
    <Joyride
      steps={steps}
      run={runTour}
      continuous
      scrollToFirstStep
      showProgress
      showSkipButton
      disableOverlayClose={true}
      callback={onCallback}
      styles={{
        options: {
          primaryColor: "#4F46E5",
          textColor: "#1F2937",
          backgroundColor: "#FFFFFF",
          overlayColor: "rgba(15, 23, 42, 0.72)",
          spotlightPadding: 10,
          zIndex: 10000,
          arrowColor: "#4F46E5",
        },
        tooltipContainer: {
          textAlign: "left",
          lineHeight: 1.5,
        },
        tooltip: {
          width: "min(390px, calc(100vw - 32px))",
          maxWidth: "calc(100vw - 32px)",
          padding: 0,
          overflow: "hidden",
          borderRadius: "18px",
          boxShadow: "0 24px 70px -20px rgba(15, 23, 42, 0.55)",
          border: "1px solid rgba(148, 163, 184, 0.28)",
        },
        tooltipTitle: {
          background: "linear-gradient(120deg, #4338CA 0%, #6D4AFF 100%)",
          color: "#FFFFFF",
          fontSize: "1.05rem",
          fontWeight: "700",
          lineHeight: 1.35,
          margin: 0,
          padding: "19px 24px",
        },
        tooltipContent: {
          color: "#475569",
          fontSize: "0.94rem",
          lineHeight: 1.65,
          padding: "20px 24px 8px",
        },
        tooltipFooter: {
          alignItems: "center",
          borderTop: "1px solid #E2E8F0",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "12px",
          padding: "14px 20px 18px",
        },
        tooltipFooterSpacer: {
          flex: 1,
        },
        buttonClose: {
          display: "none",
        },
        buttonNext: {
          backgroundColor: "#4F46E5",
          borderRadius: "10px",
          boxShadow: "0 5px 12px rgba(79, 70, 229, 0.24)",
          color: "#FFFFFF",
          fontSize: "0.875rem",
          fontWeight: "600",
          padding: "10px 16px",
        },
        buttonBack: {
          backgroundColor: "#EEF2FF",
          borderRadius: "10px",
          color: "#4338CA",
          fontSize: "0.875rem",
          fontWeight: "600",
          marginLeft: "auto",
          marginRight: "8px",
          padding: "10px 14px",
        },
        buttonSkip: {
          color: "#64748B",
          fontSize: "0.875rem",
          fontWeight: "600",
          padding: "8px 0",
        },
        beacon: {
          inner: {
            backgroundColor: "#4F46E5",
          },
          outer: {
            backgroundColor: "rgba(79, 70, 229, 0.24)",
            border: "2px solid #4F46E5",
          },
        },
        spotlight: {
          borderRadius: "12px",
          boxShadow: "0 0 0 9999px rgba(15, 23, 42, 0.48)",
          margin: 2,
        },
      }}
      locale={{
        back: "Back",
        close: "Close",
        last: "Finish",
        next: "Next",
        nextLabelWithProgress: "Next ({step}/{steps})",
        skip: "Skip Tour",
      }}
    />
  );
};

export default TourGuide;
